import { render, staticRenderFns } from "./ViewAnswers.vue?vue&type=template&id=fc468420&scoped=true&"
import script from "./ViewAnswers.vue?vue&type=script&lang=js&"
export * from "./ViewAnswers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc468420",
  null
  
)

export default component.exports